import { Link } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const ITRFilingForSalariedPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />

      <main className="px-6 py-12">
        <article className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-3" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            ITR Filing for Salaried Employees in India
          </h1>

          <p className="text-sm opacity-60 mb-8">
            A simple guide to file income tax return using Form 16, salary details, deductions, and TDS.
          </p>

          <div className="space-y-6 text-[15px] leading-7 opacity-90">
            <p>
              Salaried employees usually file their Income Tax Return using Form 16 issued by the employer. Form 16 contains salary income, deductions, taxable income, and TDS details required for ITR filing.
            </p>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Documents Needed for Salaried ITR Filing
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Form 16 from employer</li>
                <li>PAN and Aadhaar details</li>
                <li>Form 26AS / AIS details</li>
                <li>Bank account details</li>
                <li>Investment proofs, if claiming deductions</li>
                <li>Rent receipts, if claiming HRA</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Which ITR Form Is Used?
              </h2>
              <p>
                Most salaried individuals use ITR-1 if income is simple and there are no complex capital gains or business income. If there are capital gains, multiple house properties, or other complexities, ITR-2 may be needed.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Common Deductions for Salaried Employees
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Section 80C: LIC, PPF, ELSS, EPF, tuition fees</li>
                <li>Section 80D: health insurance premium</li>
                <li>HRA exemption, if eligible</li>
                <li>Home loan interest, if applicable</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Common Mistakes to Avoid
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Not matching TDS with Form 26AS</li>
                <li>Choosing the wrong assessment year</li>
                <li>Forgetting interest income</li>
                <li>Not comparing old and new tax regime</li>
              </ul>
            </section>

            <div className="rounded-xl p-5" style={{ backgroundColor: "var(--secondary)" }}>
              <h3 className="font-semibold mb-2">Want guided salaried ITR filing?</h3>
              <p className="mb-4">
                MoolTax helps salaried individuals upload documents, track progress, and complete ITR filing with guided support.
              </p>
              <Link to="/plans" className="inline-block px-5 py-2 rounded-lg text-white" style={{ backgroundColor: "var(--accent)" }}>
                View Filing Plans
              </Link>
            </div>
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ITRFilingForSalariedPage;